<template>
  <div class="middle-parent" @click.stop @touchend.stop>
      <!-- loader-->
      <div class="loader-wrapper" v-if="active==='loading'">
        <div class="loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
      </div>
       <!-- loader-->

       <!--playpauser <optional>-->
       <component 
            v-show="active==='playpause'"
            v-if="playerLoaded && components.playpauser"
            :is="components.playpauser"
            :icons="icons"
            :videoController="player.videoController"
            :contentPlaying="contentPlaying"
            :userActive="userActive"
            :ended="ended"
        />
       <!--playpauser -->

       <!--interval-loader-->
       <!--interval-loader-->
  </div>
</template>

<script>
export default {
    props:{
        components:{type:Object,required:true},
        loading:{type:Boolean,required:true},
        userActive:{type:Boolean,default:false},
        interval:{type:Boolean,default:false},
        icons:{type:Object,required:true},
        player:{type:Object,required:true},
        contentPlaying:{type:Boolean,default:false},
        playerLoaded:{type:Boolean,default:false},
        ended:{type:Boolean,default:false}
    },
    computed:{
        active(){
            if(this.loading)return 'loading';
            if(this.interval)return 'interval';
            else return 'playpause';
        }
    }
}
</script>

<style lang='scss' scoped>
@import '@video/src/scss/_mixins.scss';
.middle-parent{
    width:100%;
    margin:auto;
    @include flex;

    .loader-wrapper{
        position:relative;
        width:80px;
        height:80px;
        .loader div{
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 80px;
            height: 80px;
            border: 4px solid lightgrey;
            border-radius: 50%;
            animation: loading 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: lightgrey transparent transparent transparent;
            }
            @for $i from 1 through 3{
                .loader div:nth-child(#{$i}){
                    animation-delay:$i * -0.12s;
                }
            }
            @keyframes loading {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
    }
}
</style>